import React from 'react';

const videos = [
  { year: '2024', id: 'EWKyiym4VI0', title: 'World Space Week 2024' },
  { year: '2023', id: '9b1VAyAFmXc', title: 'World Space Week 2023' },
  { year: '2021', id: '22lMABV5T_4', title: 'World Space Week 2021' },
  { year: '2019', id: 'w_xDJ6UOQWk', title: 'World Space Week 2019' },
  { year: '2016', id: 'IIYu7LbP1D8', title: 'World Space Week 2016' },
  { year: '2014', id: 'OJAZRgjCGew', title: 'World Space Week 2014' },
  { year: '2013', id: 'TquzmShzHHg', title: 'World Space Week 2013' },
];

const WorldSpaceWeekVideos = () => (
  <section className="world-space-week-videos" aria-labelledby="world-space-week-videos-title">
    <div className="world-space-week-videos-inner">
      <header className="world-space-week-videos-header">
        <p className="section-eyebrow">WATCH THE JOURNEY</p>
        <h2 id="world-space-week-videos-title">World Space Week Highlights</h2>
        <div className="world-space-week-title-line" aria-hidden="true" />
      </header>

      <div className="world-space-week-video-grid">
        {videos.map((video) => (
          <article className="world-space-week-video-card" key={video.year}>
            <div className="world-space-week-video-frame">
              <iframe
                src={`https://www.youtube-nocookie.com/embed/${video.id}`}
                title={video.title}
                loading="lazy"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              />
            </div>
            <h3>{video.title}</h3>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default WorldSpaceWeekVideos;
